// tslint:disable:max-line-length
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { WebAuth } from 'auth0-js';
import router from '@/router';
import Axios from 'axios';
import { injectable } from 'inversify';
var AuthService = /** @class */ (function () {
    function AuthService() {
        this.auth0 = new WebAuth({
            domain: process.env.VUE_APP_AUTH0_DOMAIN_HOST,
            clientID: process.env.VUE_APP_AUTH0_CLIENT_ID,
            redirectUri: process.env.VUE_APP_BASE_URI_HOST === 'localhost' ||
                process.env.VUE_APP_BASE_URI_HOST.startsWith('10.10.')
                ? // include port number for localhost
                    process.env.VUE_APP_BASE_URI_SCHEME + "://" + process.env.VUE_APP_BASE_URI_HOST + ":" + process.env.VUE_APP_BASE_URI_PORT + process.env.VUE_APP_AUTH0_REDIRECT_URI_PATH
                : process.env.VUE_APP_BASE_URI_SCHEME + "://" + process.env.VUE_APP_BASE_URI_HOST + process.env.VUE_APP_AUTH0_REDIRECT_URI_PATH,
            audience: process.env.VUE_APP_AUTH0_AUDIENCE_SCHEME + "://" + process.env.VUE_APP_AUTH0_AUDIENCE_HOST + process.env.VUE_APP_AUTH0_AUDIENCE_PATH,
            responseType: process.env.VUE_APP_AUTH0_RESPONSE_TYPE,
            scope: process.env.VUE_APP_AUTH0_SCOPE,
        });
    }
    Object.defineProperty(AuthService.prototype, "token", {
        // ID Token
        get: function () {
            return localStorage.getItem('id_token') || '';
        },
        set: function (idToken) {
            localStorage.setItem('id_token', idToken);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "accessToken", {
        // Access Token
        get: function () {
            return localStorage.getItem('access_token') || '';
        },
        set: function (accessToken) {
            localStorage.setItem('access_token', accessToken);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "expiresAt", {
        // Expires At
        get: function () {
            return +localStorage.getItem('expires_at');
        },
        set: function (expiresIn) {
            if (expiresIn != null) {
                localStorage.setItem('expires_at', "" + (expiresIn * 1000 + new Date().getTime()));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "user", {
        // User
        get: function () {
            var userJson = JSON.parse(localStorage.getItem('user') || '{}');
            return userJson;
        },
        set: function (user) {
            localStorage.setItem('user', JSON.stringify(user));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "permissions", {
        // Permissions
        get: function () {
            var permissionsJson = JSON.parse(localStorage.getItem('permissions') || '{}');
            return permissionsJson;
        },
        set: function (permission) {
            localStorage.setItem('permissions', JSON.stringify(permission));
        },
        enumerable: false,
        configurable: true
    });
    AuthService.prototype.login = function () {
        this.auth0.authorize();
    };
    AuthService.prototype.logout = function (path) {
        if (path === void 0) { path = '/'; }
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('user');
        localStorage.removeItem('permissions');
        // tslint:disable-next-line:no-string-literal
        clearTimeout(window['tokenRenewalTimeout']);
        this.auth0.logout({
            clientID: process.env.VUE_APP_AUTH0_CLIENT_ID,
            returnTo: process.env.VUE_APP_BASE_URI_PORT === '80' ||
                process.env.VUE_APP_BASE_URI_PORT === '443'
                ? process.env.VUE_APP_BASE_URI_SCHEME + "://" + process.env.VUE_APP_BASE_URI_HOST + path
                : process.env.VUE_APP_BASE_URI_SCHEME + "://" + process.env.VUE_APP_BASE_URI_HOST + ":" + process.env.VUE_APP_BASE_URI_PORT + path,
        });
    };
    AuthService.prototype.isAuthenticated = function () {
        return new Date().getTime() < (this.expiresAt || 0);
    };
    AuthService.prototype.isAuthorized = function (page, permission, section) {
        var _this = this;
        // addition for routes, if authorize metadata contains an underscore
        // then split into separate pieces
        if (page.startsWith(this.legacyPrefix) === false && page.includes('_')) {
            var parts = page.split('_');
            switch (parts.length) {
                case 2:
                    page = parts[0];
                    section = parts[1];
                    break;
                case 3:
                    page = parts[0];
                    section = parts[1];
                    permission = parts[2];
                default:
                    page = page;
                    break;
            }
        }
        var matchingRoutes = (this.permissions || []).filter(function (element) {
            // legacy routes
            if (page.startsWith(_this.legacyPrefix)) {
                return element.key === page.replace(_this.legacyPrefix, '');
            }
            // all parts
            if (page && section && permission) {
                return element.key === page + "_" + section + "_" + permission;
            }
            // page & section only
            if (page && section && !permission) {
                return element.page === page &&
                    element.section === section &&
                    (element.permission === 'ALL' || element.permission === 'READ');
            }
            // page & permission only
            if (page && !section && permission) {
                return element.page === page &&
                    !element.section &&
                    element.permission === permission;
            }
            // page only
            if (page && !section && !permission) {
                return element.page === page &&
                    !element.section &&
                    (element.permission === 'ALL' || element.permission === 'READ');
            }
            // else return an empty array
            return [];
        });
        return matchingRoutes.length > 0;
    };
    AuthService.prototype.handleAuthentication = function () {
        var _this = this;
        this.auth0.parseHash(function (err, authResult) {
            if (authResult && authResult.accessToken && authResult.idToken) {
                _this.setSession(authResult);
                _this.setPermissionsForUser(authResult);
                _this.redirectAfterPermissions();
            }
            else {
                console.error(err);
                _this.logout();
            }
        });
    };
    /**
     * Wait until permissions have been set then redirect the uesr to dashboard
     * Poll every 500ms to see if updated
     */
    AuthService.prototype.redirectAfterPermissions = function () {
        var _this = this;
        if (!localStorage.getItem('permissions')) {
            setTimeout(function () {
                _this.redirectAfterPermissions();
            }, 500);
        }
        else {
            router.replace('/');
        }
    };
    AuthService.prototype.setSession = function (authResult) {
        this.expiresAt = authResult.expiresIn * 1000 + new Date().getTime();
        this.accessToken = authResult.accessToken;
        this.token = authResult.idToken;
        this.user = authResult.idTokenPayload;
        this.scheduleRenewal(authResult);
    };
    AuthService.prototype.renewSession = function () {
        var _this = this;
        this.auth0.checkSession({}, function (err, authResult) {
            if (authResult && authResult.accessToken && authResult.idToken) {
                _this.setSession(authResult);
            }
            else if (err) {
                _this.logout();
                console.error(err);
            }
        });
    };
    AuthService.prototype.scheduleRenewal = function (authResult) {
        var _this = this;
        // 10 minutes before expiration
        var delay = authResult.expiresIn - 10 * 60;
        // tslint:disable-next-line:no-string-literal
        window['tokenRenewalTimeout'] = setTimeout(function () { return _this.renewSession(); }, delay * 1000);
    };
    AuthService.prototype.setPermissionsForUser = function (authResult) {
        var _this = this;
        // get username
        var scheme = process.env.VUE_APP_AUTH0_DOMAIN_SCHEME;
        var host = process.env.VUE_APP_AUTH0_DOMAIN_HOST;
        var path = '/user_name';
        var username = authResult.idTokenPayload[scheme + "://" + host + path];
        var endpoint = '/api/v1/management/user/getfunctionsbyid';
        Axios.post(endpoint, { UserId: username }, {
            // tslint:disable-next-line:max-line-length
            baseURL: process.env.VUE_APP_API_GATEWAY_SCHEME + "://" + process.env.VUE_APP_API_GATEWAY_HOST + ":" + process.env.VUE_APP_API_GATEWAY_PORT + "/" + process.env.VUE_APP_API_GATEWAY_PATH,
            headers: {
                Authorization: "Bearer " + authResult.accessToken,
            },
        })
            .then(function (response) {
            if (response.status !== 200) {
                _this.logout('/forbidden');
            }
            else {
                var functions = response.data;
                var functionRegex_1 = /(\w[^_]+)_(\w[^_]+)?(?:_)?((?:ALL)|(?:READ)|(?:WRITE))\b/;
                var permissionsArray_1 = [];
                functions.forEach(function (f) {
                    var matches = functionRegex_1.exec(f);
                    if (matches && matches[2] !== undefined) {
                        // permission, page, field / section
                        permissionsArray_1.push({
                            key: f,
                            page: matches[1],
                            section: matches[2],
                            permission: matches[3],
                        });
                    }
                    else if (matches && matches[2] === undefined) {
                        // permission, page
                        permissionsArray_1.push({
                            key: f,
                            page: matches[1],
                            permission: matches[3],
                        });
                    }
                    else {
                        // legacy rule or RSL / LOCO
                        permissionsArray_1.push({
                            key: f,
                            page: f,
                            permission: 'ALL',
                        });
                    }
                });
                _this.permissions = permissionsArray_1;
            }
        })
            .catch(function (error) {
            console.error(error);
            _this.logout();
        });
    };
    Object.defineProperty(AuthService.prototype, "isLoggedInUserCarrier", {
        get: function () {
            return this.isAuthorized('CARRIER');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "legacyPrefix", {
        get: function () { return '$_'; },
        enumerable: false,
        configurable: true
    });
    AuthService = __decorate([
        injectable()
    ], AuthService);
    return AuthService;
}());
export { AuthService };
